"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCardRibbon = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../theme/colors");
var variantColors = {
    alert: { background: '#FFF6F8', border: colors_1.colors.fire[500], color: colors_1.colors.fire[500] },
    success: { background: '#F1FBF7', border: colors_1.colors.grass[400], color: '#0E5464' },
    neutral: { background: colors_1.colors.brand[100], border: colors_1.colors.brand[400], color: colors_1.colors.brand[400] },
    warning: { background: colors_1.colors.fire[100], border: colors_1.colors.peach[500], color: '#B37855' },
};
exports.StyledCardRibbon = styled_components_1.default.div(function (_a) {
    var variant = _a.variant;
    return "\n    background-color: ".concat(variantColors[variant].background, ";\n    color: ").concat(variantColors[variant].color, ";\n    padding: 8px;\n    position: relative;\n    margin: 16px -20px -16px -16px;\n  ");
});
//# sourceMappingURL=index.js.map